import Dexie, { Transaction } from "dexie";
import { IDatabaseUpgrade } from "../database-upgrade";
import { StoredDispatchedServiceSyncData } from "src/app/driver/storage/models/stored-dispatched-service-sync-data";

/**
 * Defines the upgrade path for version 11 of indexed DB.
 */
export class DatabaseUpgradeV11 implements IDatabaseUpgrade {
	/** @inheritdoc */
	public readonly Version: number = 11;

	/** @inheritdoc */
	public Upgrade(dexieInstance: Dexie): void {
		dexieInstance.version(this.Version).upgrade((transaction: Transaction) => {
			// Adds UnacceptedData to sync data to ensure consistency
			return transaction.table("DispatchedServiceSyncData").toCollection().modify((storedSyncData: StoredDispatchedServiceSyncData) => {
				if (!storedSyncData.UnacceptedData) {
					storedSyncData.UnacceptedData = null;
				}
			});
		});
	}
}